import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Shipping from '../views/Shipping.vue';
import Approve from '../views/Approve.vue';
import Confirm from '../views/Confirm.vue';
import Monitor from '../views/Monitor.vue';
import Stats from '../views/Stats.vue';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/shipping',
        name: 'Shipping',
        component: Shipping
    },
    {
        path: '/approve',
        name: 'Approve',
        component: Approve
    },
    {
        path: '/confirm',
        name: 'Confirm',
        component: Confirm
    },
    {
        path: '/compare',
        name: 'Monitor',
        component: Monitor
    },
    {
        path: '/stats',
        name: 'Stats',
        component: Stats
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router;